"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.getCartFreeGiftIds = exports.getCartItemsIdByType = exports.getCartTotal = exports.reverseObj = exports.isCheckoutPage = void 0;
function isCheckoutPage() {
    return window.location.href.includes('checkouts');
}
exports.isCheckoutPage = isCheckoutPage;
function reverseObj(object) {
    var NewObj = {}, keysArr = Object.keys(object);
    for (var i = keysArr.length - 1; i >= 0; i--) {
        NewObj[keysArr[i]] = object[keysArr[i]];
    }
    return NewObj;
}
exports.reverseObj = reverseObj;
function getCartTotal(cart) {
    this.selectors = {
        checkoutDiscountAmountTargetAttr: 'checkout-discount-amount-target',
        checkoutDiscountAmountTarget: '[data-checkout-discount-amount-target]',
        checkoutTotalTaxesTargetAttr: 'checkout-total-taxes-target',
        checkoutTotalTaxesTarget: '[data-checkout-total-taxes-target]'
    };
    var cartTotal = cart.total_price / 100;
    if (isCheckoutPage()) {
        var checkoutTotal = $('.total-line__price .payment-due__price').attr('data-checkout-payment-due-target');
        if (checkoutTotal) {
            cartTotal = parseFloat((parseFloat(checkoutTotal) / 100).toFixed(2));
        }
    }
    return cartTotal;
}
exports.getCartTotal = getCartTotal;
function getCartItemsIdByType(cart, type) {
    return cart.items
        .map(function (item) { return item.product_type === type ? item.id.toString() : ''; })
        .filter(function (id) { return (id !== ''); });
}
exports.getCartItemsIdByType = getCartItemsIdByType;
function getCartFreeGiftIds(cart) {
    var cartSampleIds = getCartItemsIdByType(cart, 'Sample');
    var cartGwpIds = getCartItemsIdByType(cart, 'GWP');
    return __spreadArrays(cartSampleIds, cartGwpIds);
}
exports.getCartFreeGiftIds = getCartFreeGiftIds;
